import clsx from 'clsx';
import {useHistory, useLocation} from 'react-router-dom';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItemIcon from '@material-ui/core/ListItemIcon';
// import DashboardIcon from '@material-ui/icons/Dashboard';
import SquareFootIcon from '@material-ui/icons/SquareFoot';
import { Fade, IconButton, Tooltip } from '@material-ui/core';
import { FanIcon } from '../assets/images/FanIcon';
import { BladeIcon } from '../assets/images/BladeIcon';
import { EngineeringIcon } from '../assets/images/EngineeringIcon';
import { BarChartIcon } from '../assets/images/BarChartIcon';
import { HubIcon } from '../assets/images/HubIcon';
import { CustomerMarketIcon } from '../assets/images/CustomerMarketIcon';
import { ProjectsIcon } from '../assets/images/ProjectsIcon';
import { HomeIcon } from '../assets/images/HomeIcon';
import FanListIcon from '../assets/images/FanListIcon';
import FanSearchIcon from '../assets/images/FanSearch';
import { ArchiveIcon } from '../assets/images/ArchieveFanIcon';
const useStyles = makeStyles(() => ({
  tooltip: {
    backgroundColor: "#4cbb94",
    color: "#fff",
    fontSize: "13px",
    padding: "6px 10px",
    borderRadius: "6px",
    fontWeight:700
  },
  arrow: {
    color: "#4cbb94",
  },
  icon: {
    transition: 'transform 200ms ease',
    '&:hover': {
      transform: 'scale(1.2)',
    },
  }
}));


interface DrawerProps{
    user: {
        username: string,
        email: string,
        userType: number
    },
    classes:any,
    handleDrawerClose: Function,
    open: boolean
}

export default function AppDrawer({user,classes,handleDrawerClose,open}:DrawerProps) {
  const theme = useTheme();
  const history = useHistory();

  const location = useLocation();
  const classesAppend = useStyles();
  const routes = [
  {
    url: "/projects",
    name: "Projects",
    icon: <ProjectsIcon className={classesAppend.icon}/>,
    allowedUser:[1,2,3,4]
  },
  {
    url: "/fans",
    name: "Fans Upload",
    icon: <FanIcon className={classesAppend.icon}/>,
    allowedUser:[1,2]
  },
  {
    url: "/search",
    name: "Fans List",
    icon: <FanListIcon className={classesAppend.icon}/>,
    allowedUser:[1,2]
  },
  {
    url: "/ga-drawings",
    name: "GA Drawings",
    icon: <EngineeringIcon className={classesAppend.icon}/>,
    allowedUser:[1,2]
  },
  {
    url: "/blade-models",
    name: "Blade",
    icon: <BladeIcon className={classesAppend.icon}/>,
    allowedUser:[1,2]
  },
  {
    url: "/hubs",
    name: "Hubs",
    icon: <HubIcon className={classesAppend.icon}/>,
    allowedUser:[1,2]
  },
  {
    url: "/octave-bands",
    name: "Octave Bands",
    icon: <BarChartIcon className={classesAppend.icon}/>,
    allowedUser:[1,2]
  },
  {
    url: "/archive",
    name: "Archived Fans ",
    icon: <ArchiveIcon className={classesAppend.icon}/>,
    allowedUser:[1,2]
  }
]

  return (
    <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
      <div className={classes.toolbar}>
        <IconButton onClick={()=>handleDrawerClose()}>
          {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </div>
      <Divider />
      <List>
        <Tooltip
        key={10}
        title={'Home'}
        placement="right"
        arrow
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 120 }}
        classes={{ tooltip: classesAppend.tooltip, arrow: classesAppend.arrow }}
      >
          <ListItem button onClick={()=>history.push('/')}>
            <ListItemIcon><HomeIcon /></ListItemIcon>
            <ListItemText style={{color:'white'}} primary="Home"/>
          </ListItem>
          </Tooltip>
          <Divider />
          {routes
          .filter(route => route.allowedUser.includes(user.userType))
          .map((route, i) => (
            <Tooltip
              key={i}
              title={route.name}
              placement="right"
              arrow
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 120 }}
              classes={{ tooltip: classesAppend.tooltip, arrow: classesAppend.arrow }}
            >
              <ListItem
                button
                className={location.pathname === route.url ? "active-link" : ""}
                onClick={() => history.push(route.url)}
              >
                <ListItemIcon>{route.icon}</ListItemIcon>
                <ListItemText style={{ color: "white" }} primary={route.name} />
              </ListItem>
            </Tooltip>
          ))}
          {
            user.userType===1 &&
            <Divider />
          }
          {
            user.userType===1 &&
            <Tooltip
        key={10}
        title={'Manage Users'}
        placement="right"
        arrow
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 120 }}
        classes={{ tooltip: classesAppend.tooltip, arrow: classesAppend.arrow }}
      >
            <ListItem button onClick={()=>history.push('/users')}>
              <ListItemIcon><CustomerMarketIcon/></ListItemIcon>
              <ListItemText style={{color:'white'}} primary="Manage Users"/>
            </ListItem>
            </Tooltip>
          }
      </List>
    </Drawer>
  );
}
